module.exports = __webpack_public_path__ + "img/menumega.0b2fe438.png";